export interface ISeoProps {
	title: string;
	description: string;
}

export type seoPageTypes =
	| 'withdrawals'
	| 'business-withdrawals'
	| 'transactions'
	| 'security'
	| 'settings'
	| 'home'
	| 'assets'
	| 'analytics'
	| 'kyb'
	| 'reset-password'
	| 'login'
	| 'addresses'
	| 'developer';

export const seoData: Record<seoPageTypes, ISeoProps> = {
	'withdrawals': {
		title: 'Withdrawals - Breet VIP',
		description: 'Manage withdrawals efficiently and securely with Breet Partnership.',
	},
	'business-withdrawals': {
		title: 'Business Withdrawals - Breet VIP',
		description: 'Manage business withdrawals efficiently and securely with Breet Partnership.',
	},
	'transactions': {
		title: 'Transactions - Breet VIP',
		description: 'Track, review, and manage all your business transactions securely in Breet Partnership.',
	},
	'security': {
		title: 'Settings | Security - Breet VIP',
		description: 'Secure your account with 2FA and more.',
	},
	'settings': {
		title: 'Settings - Breet VIP',
		description: 'Update account preferences, security settings, and compliance details in Breet Partnership.',
	},
	'home': {
		title: 'Dashboard - Breet VIP',
		description:
			'Get a complete overview of your business operations and verification status on the Breet Partnership dashboard.',
	},
	'assets': {
		title: 'Assets - Breet VIP',
		description: 'Manage and monitor your verified business assets with Breet Partnership.',
	},
	'analytics': {
		title: 'Analytics - Breet VIP',
		description: 'Access detailed analytics and insights to track your business performance in Breet Partnership.',
	},
	'kyb': {
		title: 'Breet KYB & Compliance - Breet',
		description:
			'Our KYB process is built for speed, trust, and compliance; so your business can get verified and scale confidently without friction.',
	},
	'reset-password': {
		title: 'Reset Password - Breet VIP',
		description: 'Reset your Breet Partnership password to regain secure access to your account.',
	},
	'login': {
		title: 'Login - Breet VIP',
		description:
			'Securely log in to your Breet Partnership account to manage verification, transactions, and business operations.',
	},
	'addresses': {
		title: 'Wallet Addresses - Breet VIP',
		description: 'Manage and monitor your verified business assets with Breet Partnership.',
	},
	'developer': {
		title: 'Developer - Breet VIP',
		description: 'Manage and monitor your verified business assets with Breet Partnership.',
	},
};
